export default __webpack_public_path__ + "static/media/NM_Consumer_Informational_Brochure__Amended_8_27_18_.39cb7019.pdf";